module.exports = __webpack_public_path__ + "media/images/icons/vendors/weddingdress-050af75a5f22e30bea84c10102807b83.png";